import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Always include stored Bearer token in every request (fallback for Preview envs
// where SameSite=lax cookies may not be sent on POST/PUT/DELETE)
api.interceptors.request.use(config => {
  const token = localStorage.getItem('dc_access_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});
